// react
import { useEffect } from "react";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";
import {
  getPostChargeList,
  createPostCharge,
  CHARGE_POST_SUBMIT,
} from "~/redux/actions/post";
import { setUserInfo, resetUserInfo } from "~/redux/actions/user";

// views
import Loading from "~/components/app/Loading";
import PostChargeButton from "~/components/post/PostChargeButton";
import PostChargeList from "~/components/post/PostChargeList";
import { Row, Col, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

import { authUrlSilently, isWechatBrowser } from "~/utils/wechat";
import { useRouter } from "next/router";

const isWechat = isWechatBrowser();

const PostChargeBlock = (props) => {
  const router = useRouter();
  // props
  const hasCharges = props.postCharges && props.postCharges.length;
  const hasCharged = props.postCharges && props.postCharged;
  const isAuthor = props.user && props.user.id === props.post.user.id;

  // handles
  const handleFetch = () => {
    props.getPostChargeList(props.token, props.post.id);
  };
  const handleDialog = () => {
    if (props.token) {
      if (props.user.ele >= 1) {
        // 当我的电量大于1(充电所需最小电量值)时，打开充电窗口。
        props.showAppModal("PostChargeModal");
      } else {
        // 当我的电量小于1(充电所需最小电量值)时，提示电量不足。
        Modal.confirm({
          title: "电量余额不足",
          okText: "去充电",
          closable: true,
          content: (
            <div>
              <p>哎呀，您的电量不足啦！可付费充电，支持社区发展哦：）</p>
              <p>
                <a
                  href="https://eleduck.com/posts/6GzfGe"
                  className="text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  电量的作用及如何获取电量？
                </a>
              </p>
            </div>
          ),
          onOk() {
            if (isWechat) {
              router.push({
                pathname: "/profile/info",
                query: { redirectUrl: router.asPath },
              });
            } else {
              props.showAppModal("TopUpModal");
            }
          },
        });
      }
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };
  const handleEvent = () => {
    const { name, data } = props.event;
    if (name === CHARGE_POST_SUBMIT) {
      props.createPostCharge(props.token, props.post.id, data);
    }
  };

  // views
  const renderChargeButton = () => {
    if (!hasCharged) {
      return (
        <Col>
          <PostChargeButton onClick={handleDialog} />
        </Col>
      );
    }
  };
  const renderChargeList = () => {
    if (hasCharges) {
      return (
        <Col offset={hasCharged ? 0 : 1}>
          <PostChargeList
            charges={props.postCharges}
            chargesCount={props.postChargesCount}
            showCount={props.showCount}
          />
        </Col>
      );
    }
  };

  // events
  useEffect(() => {
    if (props.post?.id) {
      handleFetch();
    }
  }, [props.post?.id]);
  useEffect(() => handleEvent(), [props.event]);

  if (!props.postCharges) {
    return <Loading />;
  }

  if (isAuthor && !hasCharges) {
    return (
      <div style={{ fontSize: "16px" }}>
        <ExclamationCircleFilled
          style={{
            color: "#f66160",
            fontSize: "18px",
            marginRight: "15px",
          }}
        />
        <span style={{ verticalAlign: "text-bottom" }}>
          还没有居民为你充电，你可以分享此帖让更多人看到哦！
        </span>
      </div>
    );
  }

  return (
    <Row
      className="post-charges-block"
      type="flex"
      align="middle"
      justify={hasCharges ? "start" : "center"}
    >
      {renderChargeList()}
      {renderChargeButton()}
    </Row>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  event: state.app.event,
  postCharges: state.post.postCharges,
  postChargesCount: state.post.postChargesCount,
  postChargesEle: state.post.postChargesEle,
  postCharged: state.post.postCharged,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPostChargeList,
      createPostCharge,
      showAppModal,
      setUserInfo,
      resetUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostChargeBlock);
